import { Stack } from '@mui/material';
import { ICONS } from '@/assets/icons';
import Iconify from '@/components/Iconify';
import { ICON_SIZE_MAP } from '@/config';
import { PTypography } from '../atoms/Typography/PTypography';

type Props = { text: string };

export default function WarningHelperText({ text }: Props) {
  return (
    <Stack component="span" direction="row" alignItems="center" spacing={0.5}>
      <Iconify icon={ICONS.INFO_CONTAINED} width={ICON_SIZE_MAP.sm} height={ICON_SIZE_MAP.sm} color="warning.main" />
      <PTypography variant="caption" color="warning.main">
        {text}
      </PTypography>
    </Stack>
  );
}
